export class OutpCaps {
    xHasScrOutp: boolean;
    xHasPrnOutp: boolean;

    constructor(obj?: any) {
        this.xHasScrOutp = (obj && obj.xHasScrOutp) || null;
        this.xHasPrnOutp = (obj && obj.xHasPrnOutp) || null;
    }
}
